__turbopack_context__.v({
  "captions": "saltSlider-module-scss-module__0yrtRW__captions",
  "control": "saltSlider-module-scss-module__0yrtRW__control",
  "disabled": "saltSlider-module-scss-module__0yrtRW__disabled",
  "fill": "saltSlider-module-scss-module__0yrtRW__fill",
  "grain": "saltSlider-module-scss-module__0yrtRW__grain",
  "input": "saltSlider-module-scss-module__0yrtRW__input",
  "knob": "saltSlider-module-scss-module__0yrtRW__knob",
  "picked": "saltSlider-module-scss-module__0yrtRW__picked",
  "pop": "saltSlider-module-scss-module__0yrtRW__pop",
  "prompt": "saltSlider-module-scss-module__0yrtRW__prompt",
  "rail": "saltSlider-module-scss-module__0yrtRW__rail",
  "reading": "saltSlider-module-scss-module__0yrtRW__reading",
  "readout": "saltSlider-module-scss-module__0yrtRW__readout",
  "scale": "saltSlider-module-scss-module__0yrtRW__scale",
  "score": "saltSlider-module-scss-module__0yrtRW__score",
  "shake": "saltSlider-module-scss-module__0yrtRW__shake",
  "shaker": "saltSlider-module-scss-module__0yrtRW__shaker",
  "shakerIcon": "saltSlider-module-scss-module__0yrtRW__shakerIcon",
  "slider": "saltSlider-module-scss-module__0yrtRW__slider",
  "sprinkle": "saltSlider-module-scss-module__0yrtRW__sprinkle",
  "stop": "saltSlider-module-scss-module__0yrtRW__stop",
  "tick": "saltSlider-module-scss-module__0yrtRW__tick",
  "tier": "saltSlider-module-scss-module__0yrtRW__tier",
  "track": "saltSlider-module-scss-module__0yrtRW__track",
  "unset": "saltSlider-module-scss-module__0yrtRW__unset",
});
